<template>
  <IconComponent :class="$attrs.class" />
</template>

<script lang="ts" setup>
interface Props {
  name: string;
}

const props = defineProps<Props>();

const glob = import.meta.glob('/assets/icons/*.svg', { eager: true });

const IconComponent = computed(() => {
  const importPromise = new Promise((resolve, reject) => {
    resolve(glob[`/assets/icons/icon--${props.name}.svg`]);
  });

  return defineAsyncComponent(() => importPromise);
});
</script>
